/**
 * Função que mapeia um objeto, transformando os seus valores através de uma função de transformação.
 *
 * @param obj - Objeto de entrada cujas chaves são strings e os valores são arrays de strings.
 * @param transform - Função que recebe uma chave e seu respectivo valor e retorna um boolean.
 * @returns Um novo objeto com as mesmas chaves do objeto original, onde cada valor foi transformado em um boolean.
 */
export const mapObject = <T extends Record<string, string[]>>(
  obj: T,
  transform: (key: keyof T, value: T[keyof T]) => boolean
): { [K in keyof T]: boolean } => {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key,
      transform(key as keyof T, value as T[keyof T]),
    ])
  ) as { [K in keyof T]: boolean };
};

export const checkPermission = (
  names: string[],
  permissoes: Set<string>,
  partial = false
): boolean => {
  if (partial) {
    return names.some((name) => permissoes.has(name.toLowerCase()));
  }

  return (
    names.length === 0 ||
    names.every((name) => permissoes.has(name.toLowerCase()))
  );
};
